import React, { useState } from "react";
import api from "../chat/api"; // or wherever your API helper is
import { useEffect } from "react";
import { toast } from "../../utils/appToast";

const EditTagModal = ({
  isOpen,
  onClose,
  tagId,
  initialName,
  initialColor,
  initialDescription,
  onSuccess,
}) => {
  const [name, setName] = useState(initialName || "");
  const [color, setColor] = useState(initialColor || "");
  const [description, setDescription] = useState(initialDescription || "");
  const [loading, setLoading] = useState(false);

  const colorOptions = [
    "#D8FF75", "#7FFF7A", "#7AFFCE", "#7AEDFF", "#7ABEFF",
    "#7A9FFF", "#B27AFF", "#E97AFF", "#FF7AD7", "#FF7AA5",
    "#FF7A7A", "#FFFFFF", "#F7F7F7"
  ];

  useEffect(() => {
  if (isOpen) {
    setName(initialName || "");
    setColor(initialColor || "");
    setDescription(initialDescription || "");
  }
}, [isOpen, initialName, initialColor, initialDescription]);


  const handleUpdate = async () => {
    if (!name || !color) return;

    try {
      setLoading(true);
      await api.put(`/api/tagging/tags/${tagId}/`, {
        name,
        color,
        description,
      });
      onSuccess?.(); // refresh parent
      onClose();
   } catch (err) {
       const msg =
         err?.response?.data?.detail ||
         err?.message ||
         "Failed to create tag. Please try again.";
   
       toast.error(msg, {
         position: "top-right",
         autoClose: 4000,
         closeOnClick: true,
         pauseOnHover: true,
         draggable: true,
       });
     
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="custom-modal-overlay-inline show">
      <div className="custom-modal-content-custom active relative w-[420px]">
        <button className="close-modal-custom" onClick={onClose}>×</button>

        <h2 className="text-lg font-semibold mb-1">Edit Tag</h2>
        <p className="text-[13px] font-[400] font-[Outfit] leading-normal text-[#73607B] mb-4">
          Update the tag details below.
        </p>

        <label className="text-[#18101C] font-[500] text-[15px] mb-1">Name</label>
        <input
          type="text"
          className="w-full border border-[rgba(0,0,0,0.10)] rounded-[6px] px-4 py-4 mb-4 text-[13px]"
          placeholder="Eg: Contracts"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <label className="text-[#18101C] font-[500] text-[15px] mb-2">Color</label>
        <div className="flex flex-wrap gap-2 mb-4">
          {colorOptions.map((c, idx) => (
            <div
              key={idx}
              className="w-6 h-6 rounded-md border border-[rgba(0,0,0,0.10)] cursor-pointer"
              style={{
                backgroundColor: c,
                outline: color === c ? '2px solid black' : 'none',
              }}
              onClick={() => setColor(c)}
            />
          ))}
        </div>

        <label className="text-[#18101C] font-[500] text-[15px] mb-2">
          Description <span className="text-[13px] text-[#73607B]">(Optional)</span>
        </label>
        <textarea
          rows={3}
          className="w-full h-[94px] self-stretch rounded-[6px] border border-[rgba(0,0,0,0.10)] px-4 pt-[13px] text-[13px] font-[400] font-[Outfit] leading-normal text-[#52525B] placeholder:text-[#52525B] placeholder:opacity-64 placeholder:font-[Outfit] placeholder:text-[13px] placeholder:font-[400] placeholder:leading-normal resize-none relative focus:outline-none focus:border-[#6F52ED] hover:border-[#6F52ED]"
          placeholder="Eg: Important Contracts for FY_25"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

        <div className="absolute bottom-4 right-5 flex justify-end gap-3">
  {/* Cancel Button */}
  <button
    className="flex px-9 py-[10px] justify-center items-center gap-2 rounded-[6px] border border-[rgba(0,0,0,0.10)] bg-[#FEF9F7] text-[#52525B] font-[Outfit] text-[16px] font-semibold leading-[24px] tracking-[0.16px]"
    onClick={onClose}
  >
    Cancel
  </button>

  {/* Save Changes Button */}
  <button
    className={`flex px-7 py-[10px] justify-center items-center gap-2 rounded-[6px] bg-[#C95EBE] text-[#EAF7FF] font-[Outfit] text-[16px] font-semibold leading-[24px] tracking-[0.16px] ${
      loading ? "opacity-50 cursor-not-allowed" : "hover:bg-[#b04aad]"
    }`}
    onClick={handleUpdate}
    disabled={!name || !color || loading}
  >
    {loading ? "Saving..." : "Save Changes"}
  </button>
</div>

      </div>
    </div>
  );
};

export default EditTagModal;
